import Dto from '~/base/Dto';
import { modelFactory } from '~/base/ModelFactory';
import ApiHelper from '~/base/api/ApiHelper';

import MessagesApiRepository from './MessagesApiRepository';
import CreateMessageDto from './dto/CreateMessageDto';
import DeleteMessageDto from './dto/DeleteMessageDto';
import { MessageForm } from './forms/MessageForm';
import MessagesListItemModel from './models/MessagesListItemModel';

export default class MessagesService {
  api: MessagesApiRepository;

  constructor() {
    this.api = new MessagesApiRepository();
  }

  // API

  getList = async (documentTypeId: number, documentId: number) => {
    const params = ApiHelper.getURLSearchParams(ApiHelper.getTrimStringValues({ documentTypeId, documentId }));

    const { data } = await this.api.getList(params);

    return modelFactory.createList(MessagesListItemModel, data.data);
  };

  createMessage = async (documentTypeId: number, documentId: number, form: MessageForm) => {
    const dto = Dto.populate(CreateMessageDto, {
      documentTypeId,
      documentId,
      ...form,
    });

    const { data } = await this.api.createMessage(dto);

    return modelFactory.createList(MessagesListItemModel, data?.data);
  };

  deleteMessage = async (documentTypeId: number, documentId: number, messageId: number) => {
    const dto = Dto.populate(DeleteMessageDto, {
      documentTypeId,
      documentId,
      messageId,
    });

    const { data } = await this.api.deleteMessage(dto);

    return modelFactory.createList(MessagesListItemModel, data?.data);
  };
}
